import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SettingsSidebar from './SettingsSidebar';
import { isAdminRole } from '../../utils/roleHelpers';

const AdminLayout = ({ activeTab, children }) => {
  const navigate = useNavigate();
  const user = useSelector(state => state.auth.user);
  const isAdmin = isAdminRole(user?.role);

  const handleTabChange = (tab) => {
    navigate('/settings', { state: { activeTab: tab } });
  };

  return (
    <div className="min-h-screen bg-background py-4 px-2 sm:py-8 sm:px-4 pb-20 md:pb-4">
      <div className="mx-auto bg-card rounded-lg shadow-sm flex flex-col md:flex-row overflow-hidden border border-border">
        <SettingsSidebar
          activeTab={activeTab}
          onTabChange={handleTabChange}
          isAdmin={isAdmin}
        />
        <div className="flex-1 border-t md:border-t-0 md:border-l border-border overflow-x-auto">
          <div className="p-4 sm:p-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
